import React from 'react';
import DayCell from './DayCell';
import { justDate, isoDateString } from '../../utils/date-utils';
import { getJobCalendarDates } from '../../utils/job-dates-resolver';
import { groupEventsByDate } from '../../utils/calendar-helpers';

const WALNUT = '#8B4513';

export default function MonthGrid({
  days,
  currentMonth,
  jobs = [],
  events = [],
  forecastByDate = {},
  dayNotes = {},
  onDayClick,
  onJobClick,
  onEventClick,
  onJobDrop
}) {
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const today = justDate(new Date());
  const todayISO = isoDateString(today);

  const eventsByDate = groupEventsByDate(events);

  // Group jobs by date using the resolver
  const jobsByDate = {};
  jobs.forEach(job => {
    const dates = getJobCalendarDates(job);
    
    dates.forEach(date => {
      const dateStr = isoDateString(date);
      if (!jobsByDate[dateStr]) jobsByDate[dateStr] = [];
      jobsByDate[dateStr].push(job);
    });
  });

  return (
    <div>
      {/* Weekday Headers */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: '8px',
        marginBottom: '8px'
      }}>
        {weekdays.map(day => (
          <div
            key={day}
            style={{
              padding: '12px',
              textAlign: 'center',
              fontSize: '13px',
              fontWeight: '600',
              color: WALNUT,
              background: `${WALNUT}0A`,
              borderRadius: '8px'
            }}
          >
            {day}
          </div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: '8px'
      }}>
        {days.map((date, index) => {
          const dateISO = isoDateString(date);
          const isCurrentMonth = new Date(date).getMonth() === currentMonth;
          const isToday = dateISO === todayISO;
          const jobsForDay = jobsByDate[dateISO] || [];
          const note = dayNotes[dateISO] || null;
          const weather = forecastByDate[dateISO] || null;

          return (
            <DayCell
              key={index}
              date={date}
              isCurrentMonth={isCurrentMonth}
              isToday={isToday}
              jobs={jobsForDay}
              events={eventsByDate[dateISO] || []}
              note={note}
              weather={weather}
              onClick={onDayClick}
              onJobClick={onJobClick}
              onEventClick={onEventClick}
              onJobDrop={onJobDrop}
            />
          );
        })}
      </div>
    </div>
  );
}